import clsx from "clsx";
import { AttsIcon } from "assets/svgComponents/PresaleBlock/ConnectWallet copy";

type AgntLogoProps = {
  isHeader?: boolean;
};

const AgntLogo: React.FC<AgntLogoProps> = ({ isHeader = false }) => {
  return (
    <div
      className={clsx(
        "flex items-center gap-[0.857vw] max-lg:pl-[1.8vw] max-lg:gap-[2.4vw] lg:pl-[0.642vw]",
        isHeader &&
          "!gap-[0.571vw] max-lg:!gap-[2.13vw] "
      )}
    >
      <AttsIcon
        className={clsx(
          "size-[3.428vw] max-lg:size-[9.6vw]",
          isHeader && "max-lg:!size-[8.53vw] !size-[2.29vw]"
        )}
      />
      <h3
        className={clsx(
          "text-[2.571vw] leading-[1.1] max-lg:text-20m font-luxora-medium text-black",
          isHeader && "!text-[1.7vw] max-lg:!text-[6.4vw]"
        )}
      >
        AGNT.Hub
      </h3>
    </div>
  );
};

export default AgntLogo;
